var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoldCup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 104.508,
    height: 114.091,
    viewBox: "0 0 104.508 114.091",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trophy_1_",
    "data-name": "trophy (1)",
    transform: "matrix(0.985, -0.174, 0.174, 0.985, -13.288, 18.952)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8474",
    "data-name": "Path 8474",
    d: "M260.906,319.121a11.45,11.45,0,0,1-3.687-7.187,6.471,6.471,0,0,1-2.961.714c-.152,0-.3-.007-.45-.017V334.14c.15,0,.3-.012.45-.012a15.668,15.668,0,0,1,6.253,1.294l1.439-13.407A3.5,3.5,0,0,0,260.906,319.121Z",
    transform: "translate(-192.942 -247.868)",
    fill: "#ffdd40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8475",
    "data-name": "Path 8475",
    d: "M260.512,374.412l1.439-13.407a.017.017,0,0,0,0,0v0c-2.251,3.749-5.124,3.062-6.642,2.314a2.474,2.474,0,0,0-1.5-.226V373.13c.15,0,.3-.012.45-.012A15.673,15.673,0,0,1,260.512,374.412Z",
    transform: "translate(-192.942 -286.858)",
    fill: "#ffb332"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8476",
    "data-name": "Path 8476",
    d: "M223.192,311.934a11.449,11.449,0,0,1-3.686,7.187,3.5,3.5,0,0,0-1.045,2.894l1.44,13.407a15.668,15.668,0,0,1,6.253-1.295l0-21.48A6.468,6.468,0,0,1,223.192,311.934Z",
    transform: "translate(-164.838 -247.868)",
    fill: "#ffb332"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8477",
    "data-name": "Path 8477",
    d: "M226.233,373.132v-10.06a2.329,2.329,0,0,0-1.049.218c-4.126,1.939-6.644-2.27-6.644-2.27l1.44,13.407A15.673,15.673,0,0,1,226.233,373.132Z",
    transform: "translate(-164.917 -286.873)",
    fill: "#ff9100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8478",
    "data-name": "Path 8478",
    d: "M225.053,271.6a6.5,6.5,0,1,0,11.589,0A11.409,11.409,0,0,1,225.053,271.6Z",
    transform: "translate(-169.531 -215.817)",
    fill: "#ffdd40"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3458",
    "data-name": "Group 3458",
    transform: "translate(48.691 85.809)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8479",
    "data-name": "Path 8479",
    d: "M219.78,424.151a15.728,15.728,0,0,0-25.25,0Z",
    transform: "translate(-194.53 -417.803)",
    fill: "#ffdd40"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8480",
    "data-name": "Path 8480",
    d: "M210.47,418.154a15.752,15.752,0,0,0-15.941,6h15.313A3.625,3.625,0,0,1,210.47,418.154Z",
    transform: "translate(-145.838 -331.994)",
    fill: "#ffb332"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8481",
    "data-name": "Path 8481",
    d: "M132.669,36.886h-.012c.059,9.886,2.029,32.432,17.575,47.175a11.349,11.349,0,0,0,15.516,0c15.545-14.742,17.516-37.288,17.575-47.174Z",
    transform: "translate(-96.673 -29.309)",
    fill: "#ffdd40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8482",
    "data-name": "Path 8482",
    d: "M147.615,52.876a9.68,9.68,0,0,1,9.581-10.99h25.945c.123-1.888.171-3.576.18-5H132.657c.059,9.886,2.029,32.432,17.575,47.175a11.354,11.354,0,0,0,11.634,2.387c-9.245-10.264-12.883-23.407-14.25-33.571Z",
    transform: "translate(-96.673 -29.309)",
    fill: "#ffb332"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3459",
    "data-name": "Group 3459",
    transform: "translate(32.95 1.948)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8483",
    "data-name": "Path 8483",
    d: "M171.578,15.563H120.923a3.039,3.039,0,1,1,0-6.078h50.654a3.039,3.039,0,1,1,0,6.078Z",
    transform: "translate(-117.884 -9.485)",
    fill: "#ffe98d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8484",
    "data-name": "Path 8484",
    d: "M135.644,12.523a3.039,3.039,0,0,1,3.039-3.039h-17.76a3.039,3.039,0,0,0,0,6.078h17.76a3.039,3.039,0,0,1-3.039-3.039Z",
    transform: "translate(-84.934 -7.536)",
    fill: "#ffdd40"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3460",
    "data-name": "Group 3460",
    transform: "translate(13.493 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8485",
    "data-name": "Path 8485",
    d: "M56.061,59.052a2.251,2.251,0,0,1-.689-3.108A3.416,3.416,0,0,0,52.419,50.8h-.157a7.967,7.967,0,0,1-5.792-2.292C29.682,31.918,24.735,16.453,23.28,8.711a7.339,7.339,0,1,1,14.445-2.6l.032.186a4.752,4.752,0,0,0,4.8,3.876L45.2,10.1a2.251,2.251,0,0,1,.125,4.5l-2.636.073A9.282,9.282,0,0,1,33.322,7.08l-.037-.211A2.836,2.836,0,1,0,27.7,7.88c1.358,7.225,6.013,21.7,21.931,37.428a3.448,3.448,0,0,0,2.5.993h.056A7.92,7.92,0,0,1,59.17,58.363,2.251,2.251,0,0,1,56.061,59.052Z",
    transform: "translate(-23.151 0)",
    fill: "#ffdd40"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8486",
    "data-name": "Path 8486",
    d: "M199.688,446.519H167.719a2.71,2.71,0,0,0-2.7,2.7v7.16q2.168.868,4.432,1.537h28.509q2.262-.667,4.432-1.537v-7.16A2.71,2.71,0,0,0,199.688,446.519Z",
    transform: "translate(-122.387 -354.812)",
    fill: "#754631"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8487",
    "data-name": "Path 8487",
    d: "M165.017,449.22v7.16q2.168.868,4.432,1.537h13.812v-1.329a2.927,2.927,0,0,1,1.252-2.272.937.937,0,0,0,.25-1.169,2.118,2.118,0,0,1,.266-2.281.928.928,0,0,0,.081-.926,2.229,2.229,0,0,1,.467-2.764.908.908,0,0,0,.291-.657H167.718A2.71,2.71,0,0,0,165.017,449.22Z",
    transform: "translate(-122.387 -354.811)",
    fill: "#754631"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8488",
    "data-name": "Path 8488",
    d: "M217.563,473.923H195.138a1.621,1.621,0,0,0-1.62,1.62v4.546a50.617,50.617,0,0,0,25.665,0v-4.546A1.621,1.621,0,0,0,217.563,473.923Z",
    transform: "translate(-145.034 -376.588)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8489",
    "data-name": "Path 8489",
    d: "M207.16,476.092a.937.937,0,0,0,.25-1.169,1.917,1.917,0,0,1-.224-1H195.138a1.621,1.621,0,0,0-1.62,1.62v4.546a50.38,50.38,0,0,0,12.391,1.65v-3.375A2.926,2.926,0,0,1,207.16,476.092Z",
    transform: "translate(-145.034 -376.588)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8490",
    "data-name": "Path 8490",
    d: "M211.03,465.7H188.606a3.313,3.313,0,0,0-3.309,3.309v4.069q1.665.5,3.377.89v-4.891h22.288v4.891q1.712-.387,3.377-.89v-4.069A3.313,3.313,0,0,0,211.03,465.7Z",
    transform: "translate(-138.502 -370.055)",
    fill: "#d3dcfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8491",
    "data-name": "Path 8491",
    d: "M200.877,468.39a2.118,2.118,0,0,1,.266-2.281.876.876,0,0,0,.158-.407h-12.7a3.313,3.313,0,0,0-3.309,3.309v4.069q1.665.5,3.377.89v-4.891h12.271A.939.939,0,0,0,200.877,468.39Z",
    transform: "translate(-138.502 -370.055)",
    fill: "#bec8f7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3461",
    "data-name": "Group 3461",
    transform: "translate(60.464 16.229)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_208",
    "data-name": "Ellipse 208",
    cx: 2.242,
    cy: 2.242,
    r: 2.242,
    transform: "translate(0 42.503)",
    fill: "#ffe98d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_209",
    "data-name": "Ellipse 209",
    cx: 2.242,
    cy: 2.242,
    r: 2.242,
    transform: "translate(2.832 6.5)",
    fill: "#ffe98d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_210",
    "data-name": "Ellipse 210",
    cx: 4.018,
    cy: 4.018,
    r: 4.018,
    transform: "translate(8.548)",
    fill: "#ffe98d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3462",
    "data-name": "Group 3462",
    transform: "translate(17.352 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8492",
    "data-name": "Path 8492",
    d: "M44.54,3.69a2.812,2.812,0,0,1-.195,1.025A2.836,2.836,0,0,1,48.216,6.87l.037.211a9.282,9.282,0,0,0,9.363,7.593l2.636-.073a2.251,2.251,0,0,0-.125-4.5l-2.636.073a4.752,4.752,0,0,1-4.8-3.876l-.032-.186A7.378,7.378,0,0,0,45.216,0,7.291,7.291,0,0,0,41.94.877a2.822,2.822,0,0,1,2.6,2.813Z",
    transform: "translate(-41.94 0)",
    fill: "#ffb332"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3463",
    "data-name": "Group 3463",
    transform: "translate(71.923 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8493",
    "data-name": "Path 8493",
    d: "M311.95,59.052a2.251,2.251,0,0,0,.689-3.108,3.416,3.416,0,0,1,2.952-5.144h.157a7.967,7.967,0,0,0,5.792-2.292c16.788-16.593,21.735-32.058,23.19-39.8a7.339,7.339,0,1,0-14.444-2.6l-.032.186a4.752,4.752,0,0,1-4.8,3.876l-2.636-.073a2.251,2.251,0,0,0-.125,4.5l2.636.073A9.282,9.282,0,0,0,334.69,7.08l.037-.211a2.836,2.836,0,1,1,5.581,1.01c-1.358,7.225-6.013,21.7-21.93,37.428a3.448,3.448,0,0,1-2.5.993h-.056a7.92,7.92,0,0,0-6.976,12.063A2.251,2.251,0,0,0,311.95,59.052Z",
    transform: "translate(-307.645 0)",
    fill: "#ffdd40"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3464",
    "data-name": "Group 3464",
    transform: "translate(84.78 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8494",
    "data-name": "Path 8494",
    d: "M388.146,3.69a2.811,2.811,0,0,0,.195,1.025,2.836,2.836,0,0,0-3.871,2.155l-.037.211a9.282,9.282,0,0,1-9.363,7.593l-2.636-.073a2.251,2.251,0,0,1,.125-4.5l2.636.073A4.752,4.752,0,0,0,380,6.3l.032-.186A7.378,7.378,0,0,1,387.469,0a7.291,7.291,0,0,1,3.276.874,2.822,2.822,0,0,0-2.6,2.813Z",
    transform: "translate(-370.245 -0.001)",
    fill: "#ffb332"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldCup);
export default __webpack_public_path__ + "static/media/gold-cup.d3715e06.svg";
export { ForwardRef as ReactComponent };